document.addEventListener("DOMContentLoaded", function () {
  const ctaSelectors = document.getElementsByClassName('js-cta--selector');
  const ctaTargets = document.getElementsByClassName('js-cta--target');
  if (ctaSelectors && ctaTargets) {
    const selectors = Array.from(ctaSelectors);
    const targets = Array.from(ctaTargets);
    selectors.forEach(selector => {
      selector.addEventListener('change', (e) => {
        const target = targets.filter(x => x.dataset.ctaId == e.target.dataset.ctaId)[0];
        target.href = e.target.value;
      });
    });
  }
});